import React from 'react';
import './App.css';
import SearchBar from '../SearchBar/SearchBar';
import SearchResults from '../SearchResults/SearchResults';
import Playlist from '../Playlist/Playlist';
import Spotify from '../../util/Spotify';
import Library from '../Library/Library';

export default class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchResults: [],
      playlistName: 'My playlist',
      playlistId: '',
      playlistTracks: [],
      playlistLibrary: []
    }
    this.addTrack = this.addTrack.bind(this);
    this.removeTrack = this.removeTrack.bind(this); 
    this.updatePlaylistName = this.updatePlaylistName.bind(this) ;
    this.savePlaylist = this.savePlaylist.bind(this);
    this.search = this.search.bind(this);
    this.getLibraryTracks = this.getLibraryTracks.bind(this);
    this.deletePlaylist = this.deletePlaylist.bind(this);
  }

  addTrack(trackToAdd) {
      if(this.state.playlistTracks.find(track => track.id==trackToAdd.id)) {
        return;
      } 
      this.state.playlistTracks.push(trackToAdd) ;
      this.setState({playlistTracks: this.state.playlistTracks});
      
  }

  removeTrack(trackToRemove) {
    const playlistTracks=this.state.playlistTracks.filter((track) =>
      track.id != trackToRemove.id)
    this.setState({playlistTracks: playlistTracks});
  }

  updatePlaylistName(plName) {
      this.setState({playlistName: plName});
  }

  displayPlaylist(plName, tracks) {
      this.setState({playlistName: plName});
  }

  savePlaylist() {
    if(!this.state.playlistId) {
      const trackUris = this.state.playlistTracks.map(track => track.uri);
      Spotify.savePlaylist(this.state.playlistName, trackUris)
      .then(() => this.setState({
        playlistName: 'New Playlist',
        playlistId: '',
        playlistTracks: []  })
       )
      .then(() => this.displayLibrary())
    } else {
      const trackUris = this.state.playlistTracks.map(track => track.uri);
      Spotify.updatePlaylist(this.state.playlistId, trackUris)
      .then(() => this.setState({
        playlistName: 'New Playlist',
        playlistId: '',
        playlistTracks: []  })
       )
    }
  }

  search(userTerm) {
      Spotify.search(userTerm).then((data) => {
      this.setState({
        searchResults: data
        });
      })
  }

  displayLibrary() {
      Spotify.getLibrary().then((data) => {
        //console.log(data);
        this.setState({
          playlistLibrary: data
        });
      })
  }

  componentWillMount() {
      this.displayLibrary();
  }

  getLibraryTracks(playlistName, playlistId) {
      Spotify.getLibraryTracks(playlistId).then((data) => 
        this.setState({
          playlistName: playlistName,
          playlistId: playlistId,
          playlistTracks: data
        })
      )
  }

  deletePlaylist(playlistId) {
    Spotify.deletePlaylist(playlistId).then((data) => 
      this.setState({
        playlistId: ''
      })
    )
  }
  
  render() {
    //console.log(this.state.searchResults);
    return(
      <div>
       <h1><span className="highlight">mmm</span>usic</h1>
       <div className="App">
        <SearchBar onSearch={this.search} />
       <div className="App-playlist">
        <SearchResults searchResults={this.state.searchResults} 
              onAdd={this.addTrack} />
        <Playlist playlistName={this.state.playlistName}
              playlistId={this.state.playlistId}
              playlistTracks={this.state.playlistTracks}
              onRemove={this.removeTrack}
              onNameChange={this.updatePlaylistName}
              onSave={this.savePlaylist} />
       </div>
       <h2>Saved Playlists</h2>
       <div className="Library"> 
         <Library playlistLibrary={this.state.playlistLibrary}
              onTitleClick={this.getLibraryTracks} 
              onDelete={this.deletePlaylist}
              />
       </div>
       </div>
      </div>
    )
  }
}